/* ════════════════════════════════════════════════════
   KAMISHA - Scroll Animations
   Auto-applies .k-anim to common Kamisha section elements
   and reveals them via IntersectionObserver.
   ════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* Bail if user prefers reduced motion */
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Bail if IntersectionObserver isn't supported (old browsers just show content) */
  if (!('IntersectionObserver' in window)) return;

  /* Bail on the product page. Fading content in there left the buy box blank
     at first paint and washed the page out section by section while
     scrolling, on the one page whose job is choosing and buying. #ksRoot is
     the product section's root, so this covers the shared header drawer and
     footer on that page too. */
  if (document.getElementById('ksRoot')) return;

  /* Selectors that should animate when scrolled into view.
     Grouped per Kamisha section. */
  var TARGETS = [
    /* HEADER drawer items (not the sticky header itself) */
    '.kh-drawer-link',

    /* HOME (homekamisha.liquid) - hero excluded so it renders immediately for LCP */
    '.kh-intro__text', '.kh-intro__divider',
    '.kh-products__eyebrow', '.kh-products__title', '.kh-pcard', '.kh-products__link',
    '.kh-story__eyebrow', '.kh-story__title', '.kh-story__body', '.kh-story__btn', '.kh-story__img',
    '.kh-engravings__eyebrow', '.kh-engravings__title', '.kh-engravings__subtitle',
    '.kh-engravings__grid > *', '.kh-process__step',
    '.kh-quote__text', '.kh-quote__author',
    '.kh-trust__item', '.kh-testimonial',
    '.kh-cta__title', '.kh-cta__text', '.kh-cta__btn',

    /* COLLECTION (thecollectionkamisha.liquid) */
    '.kc-header > *', '.kc-card', '.kc-trust__item',

    /* COLLECTION CARDS section */
    '.kcc-card', '.kcc-header > *',

    /* PRODUCT PAGE: deliberately none. Fading the buy box in left the whole
       right-hand column blank at first paint and washed the page out section
       by section while scrolling. The product page renders fully visible. */

    /* SEARCH RESULTS */
    '.ksr-header > *', '.ksr-card',

    /* CART page */
    '.kc-cart__header > *', '.kc-cart__item', '.kc-cart__summary > *',

    /* FAQ */
    '.kfaq__header > *', '.kfaq__category', '.kfaq__contact',

    /* SECURITY / NGISHUT */
    '.ksec__header > *', '.ksec__section',

    /* PRIVACY POLICY */
    '.kpriv__header > *', '.kpriv__section',

    /* REFUND POLICY */
    '.kref__header > *', '.kref__section',

    /* TERMS OF SERVICE */
    '.kterm__header > *', '.kterm__section',

    /* GENERIC POLICY (Shopify Settings → Legal) */
    '.kpol__header > *', '.kpol__content',

    /* ABOUT */
    '.ka-hero > *', '.ka-section > *', '.ka-quote > *',

    /* CONTACT */
    '.kcc-form', '.kcc-info > *',

    /* FOOTER */
    '.kf-quote-block', '.kf-actions', '.kf-legal', '.kf-bottom > *',

    /* ICONS section (kamisha-icons) */
    '.kamisha-icon-block, .ki-block'
  ];

  var selector = TARGETS.join(',');

  /* Collect matching elements */
  var nodes;
  try {
    nodes = document.querySelectorAll(selector);
  } catch (e) {
    return;
  }

  if (!nodes.length) return;

  /* Group elements by their parent so siblings stagger together */
  var staggerMap = new Map();

  /* Apply .k-anim and stagger delay */
  for (var i = 0; i < nodes.length; i++) {
    var el = nodes[i];

    /* Skip if already animated or inside a search drawer / modal */
    if (el.classList.contains('k-anim')) continue;
    if (el.closest && (el.closest('#kamisha-search-drawer') || el.closest('#kamisha-cart-drawer'))) continue;

    el.classList.add('k-anim');

    /* Stagger same-parent siblings (max d8 - the engravings grid has 8 chips,
       and capping at 6 made chips 7 and 8 appear with no delay at all) */
    var parent = el.parentNode;
    if (parent) {
      var idx = staggerMap.get(parent) || 0;
      if (idx > 0 && idx <= 8) {
        el.classList.add('k-anim--d' + idx);
      }
      staggerMap.set(parent, idx + 1);
    }
  }

  /* Re-query so we observe only marked elements */
  var animated = document.querySelectorAll('.k-anim:not(.is-in-view)');

  var io = new IntersectionObserver(function (entries) {
    for (var j = 0; j < entries.length; j++) {
      var entry = entries[j];
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in-view');
        io.unobserve(entry.target);
      }
    }
  }, {
    threshold: 0.08,
    rootMargin: '0px 0px -6% 0px'
  });

  for (var k = 0; k < animated.length; k++) {
    io.observe(animated[k]);
  }

  /* Safety net: after 4 seconds, reveal anything still hidden
     (in case observer never fires for some reason) */
  setTimeout(function () {
    var stuck = document.querySelectorAll('.k-anim:not(.is-in-view)');
    for (var m = 0; m < stuck.length; m++) {
      stuck[m].classList.add('is-in-view');
    }
  }, 4000);

})();
